import type {
  Paginated,
  AdminNotiQuery,
  NotificationItem,
  MarkReadResponse,
  NotificationQuery,
  BulkMarkReadResponse,
  AdminNotificationItem,
  MyNotificationsResponse,
  AdminNotificationsResponse,
} from 'src/@types/notification';

import axiosInstance, { endpoints, buildQuery } from 'src/utils/axios';

export async function getMyNotifications(params: {
  limit?: number;
  cursor?: string | null;
  q?: string;
}): Promise<MyNotificationsResponse> {
  const { limit = 20, cursor, q } = params || {};
  const res = await axiosInstance.get<MyNotificationsResponse>(
    endpoints.notification.NOTIFICATIONS_MINE,
    {
      params: {
        limit,
        q,
        ...(cursor ? { cursor } : {}),
      },
    }
  );
  return res.data;
}

export async function getNotifications(params: NotificationQuery) {
  const query: any = { ...params };
  if (typeof params.isRead === 'boolean') query.isRead = params.isRead ? 'true' : 'false';
  if (typeof params.delivered === 'boolean') query.delivered = params.delivered ? 'true' : 'false';
  const { data } = await axiosInstance.get<Paginated<NotificationItem>>(
    endpoints.notification.NOTIFICATIONS,
    {
      params: query,
    }
  );
  return data;
}

export async function getNotificationById(id: string) {
  const { data } = await axiosInstance.get<NotificationItem>(
    endpoints.notification.NOTIFICATION_BY_ID(id)
  );
  return data;
}

export async function markNotificationRead(id: string, read = true) {
  const { data } = await axiosInstance.patch<MarkReadResponse>(endpoints.notification.MARK(id), {
    read,
  });
  return data;
}

export async function markNotificationsReadBulk(ids: string[], read = true) {
  const { data } = await axiosInstance.patch<BulkMarkReadResponse>(
    endpoints.notification.MARK_READ_BULK,
    {
      ids,
      read,
    }
  );
  return data;
}

/**
 * Administrator
 */
export async function fetchAdminNotifications(query?: AdminNotiQuery) {
  const qs = buildQuery(query ?? {});
  const { data } = await axiosInstance.get<AdminNotificationsResponse>(
    endpoints.notification.ADMIN(qs)
  );
  return data;
}
export async function fetchAdminNotificationDetail(id: string) {
  const { data } = await axiosInstance.get<AdminNotificationItem>(
    endpoints.notification.ADMIN_DETAIL_ID(id)
  );
  return data;
}
